<!-- form-book.component.html -->
<breadcrumb [items]="breadcrumb" />
<h1 class="mb-4">{{ title }}</h1>

<div class="row justify-content-center">
    <div class="col-12 col-lg-8">
        <div class="card shadow-sm">
            <div class="card-header">
                <span class="fw-semibold">Arquivo PDF <span class="text-danger">*</span></span>
            </div>
            <div class="card-body">
                <div class="alert alert-info d-flex align-items-center gap-2" role="alert">
                    <i class="bi bi-info-circle-fill"></i>
                    <span>O tamanho máximo permitido para o livro é de {{ maxFileSizeMb }} MB.</span>
                </div>
                <div
                    class="border border-2 rounded p-5 text-center"
                    [class.border-secondary]="!isDragging"
                    [class.border-primary]="isDragging"
                    [class.bg-primary]="isDragging"
                    [class.bg-opacity-10]="isDragging"
                    [style.border-style]="'dashed'"
                    [style.cursor]="'pointer'"
                    (dragover)="onDragOver($event)"
                    (dragleave)="onDragLeave($event)"
                    (drop)="onDrop($event)"
                    (click)="openFileInput()"
                >
                    <input #fileInput type="file" class="d-none" accept="application/pdf" (change)="onFileChange($event)" />
                    @if (!selectedFile) {
                        <i class="bi bi-cloud-arrow-up fs-1 text-secondary"></i>
                        <p class="mb-0 mt-2 text-secondary">Arraste e solte o PDF aqui ou clique para selecionar</p>
                    } @else {
                        <div class="d-flex align-items-center justify-content-center gap-2">
                            <i class="bi bi-file-earmark-pdf fs-4 text-danger"></i>
                            <span class="text-success">{{ selectedFile.name }} ({{ (selectedFile.size / 1024 / 1024).toFixed(2) }} MB)</span>
                            <button type="button" class="btn btn-sm btn-outline-danger" (click)="removeFile(); $event.stopPropagation()">
                                <i class="bi bi-x-lg"></i>
                            </button>
                        </div>
                    }
                </div>
            </div>
            <div class="card-footer d-flex justify-content-end gap-2">
                <button class="btn btn-light" [routerLink]="['/configurations']" [queryParams]="{ tab: 'biblioteca' }">Voltar</button>
                <button class="btn btn-success" (click)="saveBook()" [disabled]="!selectedFile || loading.save">
                    <div class="spinner-border spinner-border-sm" role="status" *ngIf="loading.save"></div>
                    <span *ngIf="!loading.save">Salvar</span>
                </button>
            </div>
        </div>
    </div>
</div>
